export default __webpack_public_path__ + "static/media/GENESIS.91b7a696.png";